import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import './SuccessSolicitation.scss';
import successImg from '../../../../assets/images/success.png';

const SuccessSolicitation = (props): JSX.Element => {
  const navigate = useNavigate();
  const { params } = props;

  return (
    <div className="SuccessSolicitation">
      <div className="message-container">
        <img src={successImg} alt="" />

        <p className="service-title">
          {params.selectedService.name}
          {!!params.selectedType.id && `: ${params.selectedType.name}`}
        </p>

        <p className="message-description">
          {
            params?.choiceServiceType === 1
              ? 'Orçamento solicitado'
              : 'Serviço solicitado'
          }
          <br />
          com sucesso!
        </p>

        <p className="message-description">Em breve nossa equipe entrará em contato</p>

        <Button
          className="btn-inicio"
          onClick={
            (): void => {
              navigate('/');
            }
          }
        >
          VOLTAR PARA O INÍCIO
        </Button>
      </div>
    </div>
  );
};

SuccessSolicitation.propTypes = {
  params: PropTypes.shape({
    choiceServiceType: PropTypes.number,
    service: PropTypes.string,

    selectedService: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),

    selectedType: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  }).isRequired,
};

SuccessSolicitation.defaultProps = {};

export default SuccessSolicitation;
